"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function AvCheck(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64" },
    _react2["default"].createElement("path", { fill: "#F2B211", d: "M57.854 35.437l-8.31 8.337-.01.008a5.28 5.28 0 0 1-2.277 1.352 5.38 5.38 0 0 1-5.353-1.36l-9.94-9.936-2.295 2.294c-.436.435-.927.79-1.458 1.038a5.2 5.2 0 0 1-.83.322 5.48 5.48 0 0 1-2.47.136 5.18 5.18 0 0 1-1.038-.282 5.203 5.203 0 0 1-.958-.5 6.078 6.078 0 0 1-.877-.715h-.01l-.675-.828 6.03-6.044 4.565-4.563.016-.016v-.01a3.24 3.24 0 0 1 4.58.002l2.294 2.294 5.266-5.28 13.748 13.75z" }),
    _react2["default"].createElement("path", { fill: "#FACE32", d: "M49.535 43.782L38.827 54.486A9.63 9.63 0 0 1 32 57.318a9.648 9.648 0 0 1-6.72-2.722L6.15 35.436 19.9 21.685l5.19 5.286 2.296-2.294a3.216 3.216 0 0 1 4.572 0l-.008.01v.007l-4.565 4.563-6.03 6.044.676.83h.01c.273.273.57.506.876.715.306.2.628.37.958.5.338.128.684.224 1.038.28a5.48 5.48 0 0 0 2.47-.136c.283-.08.564-.192.83-.32a5.207 5.207 0 0 0 1.457-1.04l2.294-2.286 6.92 6.924 3.01 3.01a5.368 5.368 0 0 0 5.362 1.354 5.26 5.26 0 0 0 2.28-1.35z" }),
    _react2["default"].createElement("path", { fill: "#4F74B3", d: "M19.9 21.68L6.153 35.435l-4.597-4.612A5.336 5.336 0 0 1 0 27.057V8.014C0 7.278.597 6.68 1.333 6.68h2.493c.708 0 1.385.28 1.885.78 5.182 5.195 14.19 14.22 14.19 14.22zM64 8.014v19.05c0 1.41-.56 2.764-1.556 3.764l-4.59 4.606L44.106 21.68s9.007-9.024 14.18-14.218c.5-.502 1.178-.78 1.887-.78h2.492c.737 0 1.334.596 1.334 1.332z" })
  );
}

exports["default"] = AvCheck;
module.exports = exports["default"];